type CheckboxColor =
  | "cyan"
  | "blue"
  | "green"
  | "red"
  | "purple"
  | "orange"
  | "yellow"
  | string;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  type?: "dark" | "white";
  color?: CheckboxColor;
}

export function Checkbox(props: Props) {
  const { className, type = "white", color = "cyan", ...rest } = props;

  const colorClasses = {
    cyan: "accent-cyan",
    blue: "accent-blue-500",
    green: "accent-green-600",
    red: "accent-red-500",
    purple: "accent-purple-500",
    orange: "accent-orange-500",
    yellow: "accent-yellow-500",
  };

  // If type is white, use Tailwind accent classes or inline style for custom colors
  if (type === "white") {
    const isPredefinedColor = color in colorClasses;
    const colorClass = isPredefinedColor
      ? colorClasses[color as keyof typeof colorClasses]
      : "";
    const style = !isPredefinedColor ? { accentColor: color } : undefined;

    return (
      <input
        type="checkbox"
        {...rest}
        style={style}
        className={`h-4 w-4 rounded cursor-pointer ${colorClass} ${className}`}
      />
    );
  }

  // If type is dark, use original dark styling (no color changes)
  return (
    <label
      className={`remember-me ${className}`}
      style={{
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        color: "#cccccc",
      }}
    >
      <input type="checkbox" style={{ display: "none" }} {...rest} />
      <span
        className="checkmark"
        style={{
          width: 18,
          height: 18,
          border: "2px solid #888888",
          borderRadius: 3,
          marginRight: 8,
          position: "relative",
          transition: "all 0.3s ease",
          background: rest.checked ? "#1E88A8" : "transparent",
          borderColor: rest.checked ? "#3498db" : "#637381",
        }}
      >
        {rest.checked && (
          <span
            style={{
              content: "",
              position: "absolute",
              left: 5,
              top: 1,
              width: 6,
              height: 10,
              border: "solid white",
              borderWidth: "0 2px 2px 0",
              transform: "rotate(45deg)",
              display: "block",
            }}
          />
        )}
      </span>
    </label>
  );
}
